import { render, staticRenderFns } from "./mdl-prenota.vue?vue&type=template&id=54fe2179&"
import script from "./mdl-prenota.vue?vue&type=script&lang=js&"
export * from "./mdl-prenota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports